import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import cn from "classnames";
import "./style.less";
import { currencyFormat } from "utils/stringFunction";

const CardPricing = ({ label, price, pricePer }) => {
  return (
    <div className="card-price">
      <span className="text-gray-badge tracking-2 text-14-24">{label}</span>
      <div>
        <span className="tracking-2 text-14-18 text-gray-badge font-bold">
          {price}
        </span>
        {pricePer && (
          <span className="tracking-2 text-12-22 text-gray-dark ml-5">
            / {pricePer}
          </span>
        )}
      </div>
    </div>
  );
};

const CardActivitiesPricing = ({
  title,
  priceList,
  className,
  showPricePer,
  smallInfo,
  currency,
}) => {
  const { t } = useTranslation("homepage");
  const currencyTranslation =
    currency === "IDR" ? "currency_idr" : currency === "JPY" && "currency_jpy";

  return (
    <div className={cn("w-full bg-white", { [className]: className })}>
      <div className="py-6 mb-20 border-b border-gray-light">
        <p className="font-mulish text-gold font-bold text-12 uppercase tracking-8">
          {title}
        </p>
      </div>
      <div>
        {priceList.map((item) => (
          <CardPricing
            label={item.label}
            price={t([currencyTranslation], {
              nominal: `${currencyFormat(item?.price, currency)}++`,
            })}
            pricePer={showPricePer && t("person")}
          />
        ))}
      </div>
      {smallInfo && (
        <span className="block font-mulish text-12-20 text-gray-dark mt-10">
          {smallInfo}
        </span>
      )}
    </div>
  );
};

CardActivitiesPricing.defaultProps = {
  showPricePer: true,
  currency: "IDR",
};

export { CardPricing, CardActivitiesPricing };
